import React from 'react'
import Navbar from '../Components/Navbar'
import Team from '../Components/Team'
import Footer from '../Components/Footer'
import Copyright from '../Components/Copyright'

export default function TeamLayout() {
  return (
    <div>
      <Navbar/>
      <Team/>
      <Footer/>
      <Copyright/>
    </div>
  )
}
